import React, {useState} from "react";
import Admins from "./components/Admins/Admins";
import AddAdmin from "./components/AddAdmin/Addadmin";
import {MainLayout} from "../../components/MainLayout";
import {useTranslation} from "react-i18next";
import "./Permission.styles.scss";

const Permission = ({
                        tab,
                        onAddAdmin,
                        admins,
                        handleStatusChange,
                        onChangePageHandler,
                        onSearchHandler,
                        loading,
                        onDeleteClick,
                        editAdminPhoneNumber,
                        response,
                    }) => {
    const [showForm, setShowForm] = useState(false);
    const {t} = useTranslation();

    const handleCancel = () => {
        setShowForm(false);
    };

    return (
        <MainLayout tab={tab} withSidebar={true}>
            <div className="admin_control_section">
                <h2 className={"section_title"}>{t("permissions.title")}</h2>

                <div className="d-flex justify-content-between align-items-center mb-4">
                    {showForm ? (
                        <button onClick={handleCancel} className="btn btn-secondary">
                            Hide Form
                        </button>
                    ) : (
                        <button
                            onClick={() => setShowForm(true)}
                            className="btn btn-primary"
                        >
                            <span>Add New Admin</span>
                        </button>
                    )}
                </div>

                {showForm && (
                    <AddAdmin onAddAdmin={onAddAdmin} handleCancel={handleCancel}/>
                )}

                <Admins
                    admins={admins}
                    handleStatusChange={handleStatusChange}
                    totalItems={response.totalAdmins}
                    pageSize={response.pageSize}
                    activePage={response.currentPage - 1}
                    onChangePage={onChangePageHandler}
                    onSearchHandler={onSearchHandler}
                    loading={loading}
                    onDeleteClick={onDeleteClick}
                    editAdminPhoneNumber={editAdminPhoneNumber}
                />
            </div>
        </MainLayout>
    );
};

export default React.memo(Permission);
